import * as types from './types';

const initialState = {
  loading: false,
  mensajeError: null,
  list: [],
  totalItems: 0,
  filterParams: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_VENTAS_CLIENTE_START:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case types.GET_VENTAS_CLIENTE_SUCCESS:
      return {
        ...state,
        list: payload,
        loading: false,
      };
    case types.GET_VENTAS_CLIENTE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case types.SET_FILTER_PARAMS:
      return {
        ...state,
        filterParams: payload,
      };

    case types.RESET_VENTAS_CLIENTE_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
